/**
 * HH-8: Projecten — shared vocabulary for ProjectsListView (inside
 * ManageScreen)/ProjectScreen/ProjectFormScreen. `status` values match the
 * backend ENUM exactly (ETM_Projects::VALID_STATUSES, plan §6's schema) —
 * the plan's own spec paragraph names the Dutch UI words (idee/gepland/
 * actief/klaar) only as this copy layer, same as `deadline_type` stores
 * 'soft'/'hard' rather than "streefdatum"/"harde deadline".
 *
 * Priority reuses lib/labels.js's PRIORITY_LEVELS verbatim — plan §4.5:
 * "priority (1–4, same scale the app already speaks)" — and impact reuses
 * lib/labels.js's IMPACT_OPTIONS verbatim, the same 1–3 scale/wording a
 * task's own Impact field already uses. Only "importance" is new
 * vocabulary: a project-only dimension (plan §4.5) with no task
 * equivalent to share.
 */
import { __ } from '../i18n.js';

export const PROJECT_IMPORTANCE_OPTIONS = [
  { value: 1, label: () => __('Lage belangrijkheid', 'etm') },
  { value: 2, label: () => __('Normale belangrijkheid', 'etm') },
  { value: 3, label: () => __('Hoge belangrijkheid', 'etm') },
];

export const PROJECT_STATUSES = [
  { value: 'idea', icon: 'lightbulb', label: () => __('Idee', 'etm') },
  { value: 'planned', icon: 'event', label: () => __('Gepland', 'etm') },
  { value: 'active', icon: 'bolt', label: () => __('Actief', 'etm') },
  { value: 'done', icon: 'check_circle', label: () => __('Klaar', 'etm') },
];

export function projectStatusInfo(value) {
  return PROJECT_STATUSES.find((s) => s.value === value) || PROJECT_STATUSES[0];
}
